"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const local_mock_util_1 = require("../local-mock.util");
const local_mock_constants_1 = require("../local-mock.constants");
const DEFAULT_LOCAL_MOCK = {};
const JSON_SPACES = 2;
function Item({ id, localMock = DEFAULT_LOCAL_MOCK, onLocalMockChange }) {
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)('');
    const { [local_mock_constants_1.STATE]: localMockState, ...localMockKeys } = localMock;
    const selected = localMock[localMockState.selected];
    const handleClick = () => {
        setExpanded(state => !state);
    };
    const handleChange = ({ target }) => {
        setValue(target.value);
    };
    const handleBlur = () => {
        try {
            onLocalMockChange({
                [id]: {
                    ...localMock,
                    [localMockState.selected]: value.startsWith('function') ? value : JSON.parse(value),
                },
            });
            setError(false);
        }
        catch {
            setError(true);
        }
    };
    const handleLocalMockChange = _value => {
        onLocalMockChange({
            [id]: { ...localMock, [local_mock_constants_1.STATE]: { ...localMockState, ..._value } },
        });
    };
    const handleResponseChange = ({ target }) => {
        handleLocalMockChange({ selected: target.value });
    };
    const handleStatusChange = ({ target }) => {
        handleLocalMockChange({
            status: target.value ? parseInt(target.value, 10) : '',
        });
    };
    const handleEnabledChange = () => {
        handleLocalMockChange({ enabled: !localMockState.enabled });
    };
    (0, react_1.useEffect)(() => {
        setValue(typeof selected === 'string' ? selected : JSON.stringify(selected, undefined, JSON_SPACES));
    }, [selected]);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: '10px', borderRadius: '5px', background: '#dddddd' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                    fontWeight: 700,
                    cursor: 'pointer',
                    padding: '5px',
                    display: 'flex',
                    alignItems: 'center',
                    background: expanded ? '#eeeeee' : 'transparent',
                }, onClick: handleClick, "data-testid": "title", children: [(0, jsx_runtime_1.jsx)("span", { style: { flex: 1, marginRight: '10px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }, children: id }), (0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: localMockState.enabled, onClick: local_mock_util_1.stopPropagation, onChange: handleEnabledChange })] }), (0, jsx_runtime_1.jsxs)("div", { style: {
                    padding: '5px',
                    display: expanded ? 'flex' : 'none',
                    flexDirection: 'column',
                }, "data-testid": "details", children: [(0, jsx_runtime_1.jsxs)("div", { style: { marginTop: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr' }, children: [(0, jsx_runtime_1.jsx)("select", { value: localMockState.selected, onChange: handleResponseChange, children: Object.keys(localMockKeys).map(index => ((0, jsx_runtime_1.jsx)("option", { value: index, children: index }, index))) }), (0, jsx_runtime_1.jsx)("input", { value: localMockState.status, onChange: handleStatusChange, "data-testid": "input" })] }), (0, jsx_runtime_1.jsx)("textarea", { style: {
                            border: '2px solid',
                            borderColor: error ? 'red' : 'transparent',
                            resize: 'none',
                        }, rows: 20, onChange: handleChange, onBlur: handleBlur, value: value })] })] }));
}
exports.default = (0, react_1.memo)(Item);
//# sourceMappingURL=item.component.js.map